const ARR_CONDITION_KEY = {
  // incomeTaxRate: 'incomeTaxType'
};
// const ARR_KEY_VALUE = {
//   depreciableData: 2
// };
const ARR_KEY_POSTFIX = {
  // incomeTaxRate: 'Arr'
};

const ARR_KEY = [
  'constructionInvest',
  'otherAssets',
  'immaterialAssets',

  'diffIncomeTaxRate',
  'materialConsumption',
  'ongridCapacity',
  'staffCapacity',
  'staffSalary',
  'welfareRate',
  'energyData',
  'totalInvestArr',
  'energyDataArr',
  'priceWithArr',
  'loanInterestRateArr',

  'depreciableFee',
  'diffMaintainRate',
  'diffUnitMaintainFee',
  'diffMaintainFee',
  'diffInsureRate',
  'diffUnitInsureFee',
  'diffInsureFee',
  'diffMaterialRate',
  'diffUnitMaterialFee',
  'diffMaterialFee',
  'diffUnitOtherFee1',
  'diffOtherFee1',
  'diffUnitOtherFee2',
  'diffOtherFee2'
];

/** 接口返回参数预处理 */
export function prefix(data) {
  const formData = { ...data };
  ARR_KEY.forEach(key => {
    const value = formData[key];
    const formKey = ARR_KEY_POSTFIX[key]
      ? `${key}${ARR_KEY_POSTFIX[key]}`
      : key;
    formData[formKey] = typeof value === 'string' ? value.split(',') : [];
  });
  return formData;
}

/** 保存前参数处理 */
export function postfix(data) {
  ARR_KEY.forEach(key => {
    if (ARR_KEY_POSTFIX[key]) {
      if (+data[ARR_CONDITION_KEY[key]] === 1) {
        const formKey = `${key}${ARR_KEY_POSTFIX[key]}`;
        data[key] = data[formKey].join(',');
        data[formKey] = null;
      }
    } else {
      data[key] = data[key].join(',');
    }
  });
}
